<template>
  <div class="cost_table">
    <div class="total-cost">
      {{ title }}
      <span v-if="totalCost !== null">
          <span class="info-amount">
              {{totalCost}}
          </span>
          元
      </span>
      <span v-else class="no-calculate-amount">暂未计算</span>
    </div>
    <a-table
        :columns="columns"
        :data-source="tableList"
        :pagination="false"
        :row-class-name="rowClass"
        :custom-row="customRow"
        class="amount-table"
    />
  </div>
</template>

<script>
  export default {
    name:'CostDetailsTable',
    props:{
      title:{
        type:String,
        default:''
      },
      totalCost:{
        type:Number,
        default:null
      },
      columns:{
        type:Array,
        default:()=>[]
      },
      tableList:{
        type:Array,
        default:()=>[]
      }
    },
    methods:{
      customRow() {
            return {
                on: {
                    mouseenter: (event) => {
                        this.mouseAction(event, 'add');
                    },
                    mouseleave: (event) => {
                        this.mouseAction(event, 'remove');
                        
                    },
                }
            };
        },
         mouseAction(event, type) {
            const { classList } = event.target;
            let currentClass = '';
            for (let i = 0; i < classList.length; i+=1) {
                if (/rowSpan+/.test(classList[i])) {
                    currentClass = classList[i];
                    break;
                }
            }
            const eles = document.getElementsByClassName(currentClass);
            for (let i = 0; i < eles.length; i+=1) {
                eles[i].classList[type]('ant-table-row-hover');
            }
        },
        rowClass(record) {
            return `rowSpan${record.rowType}`;
        },
    }
  }
</script>

<style lang="less" scoped>
.amount-table {
  width: 380px;
  margin-top: 14px;
  border: 1px solid #EBEDF0;
  // padding: 0 16px;
  box-sizing: content-box;
  border-radius: 2px;
  position: relative;
  &::before {
      content: '';
      position: absolute;
      display: inline-block;
      width: 10px;
      height: 10px;
      border-top: 1px solid #EBEDF0;
      border-left: 1px solid #EBEDF0;
      top: -6px;
      left: 10px;
      transform: rotate(45deg);
      border-radius: 2px;
      background: #F7F8FA;
  }
  /deep/ .ant-table-body {
      .ant-table-thead {
          th {
              background: none;
              color: #A9ABAE;
              // padding: 12px 0;
              .ant-table-column-title {
                  font-weight: 400;
              }
          }
      }
      .ant-table-tbody {
          td {
              padding: 12px;
          }
          .ant-table-row:last-of-type {
              td {
                  border: none;
              }
          }
      }
  }
}
.cost_table{
  margin-right: 24px;
}
</style>